<nav class="tabs-menu">
  <ul class="tabs">
    <li
      tabindex="-1"
      class="tab-item"
      [class.active]="selectedTab === FeeTabs.Fiat"
      (click)="selectMenuItem(FeeTabs.Fiat)"
      i18n="@@fees.tabs.fiat">
      Fiat Deposit & Withdraw
    </li>
    <li
      tabindex="-1"
      class="tab-item"
      [class.active]="selectedTab === FeeTabs.Trade"
      (click)="selectMenuItem(FeeTabs.Trade)"
      i18n="@@fees.tabs.pro">
      Lite/Pro
    </li>
    <li
      tabindex="-1"
      class="tab-item"
      [class.active]="selectedTab === FeeTabs.Crypto"
      (click)="selectMenuItem(FeeTabs.Crypto)"
      i18n="@@fees.tabs.crypto">
      Crypto Send & Receive
    </li>
  </ul>
</nav>